import { Link } from "react-router-dom";
import useAutoHoverAnimation from '../../hooks/useAutoHoverAnimation';

export default function HeroBanner() {
    const titleRef = useAutoHoverAnimation(100, 100, 600);

    return (
        <>
            <div id="hero">
                <div id="hero-video-background">
                    <img src="/images/courses-banner/course-guitar-banner.jpg" alt="Guitar Hero" />
                </div>
                <div id="hero-styles">
                    <div id="hero-caption" className="height-title content-full-width text-align-center parallax-scroll-caption">
                        <div className="inner">
                            <h1 ref={titleRef} className="hero-title caption-timeline primary-font-title">
                                <div>
                                    <span>G</span>
                                    <span>U</span>
                                    <span>I</span>
                                    <span>T</span>
                                    <span>A</span>
                                    <span>R</span>
                                    <span>&nbsp;</span>
                                    <span>(</span>
                                    <span>A</span>
                                    <span>C</span>
                                    <span>O</span>
                                    <span>U</span>
                                    <span>S</span>
                                    <span>T</span>
                                    <span>I</span>
                                    <span>C</span>
                                    <span>&nbsp;</span>
                                    <span>&</span>
                                    <span>&nbsp;</span>
                                    <span>E</span>
                                    <span>L</span>
                                    <span>E</span>
                                    <span>C</span>
                                    <span>T</span>
                                    <span>R</span>
                                    <span>I</span>
                                    <span>C</span>
                                    <span>)</span>
                                </div>
                            </h1>
                            <div className="hero-cta">
                                <Link to="/admission-form" className="cta-button">ENROLL NOW</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
} 